import type { OverlayTypeDefinition } from './types';

/**
 * Overlay type definitions - matches existing OverlayElementSchema
 */
export const OVERLAY_TYPES: Record<string, OverlayTypeDefinition> = {
  'image': {
    label: 'Image Sticker',
    requiredFields: ['assetRef'],
    optionalFields: [],
  },
  'text': {
    label: 'Text Overlay',
    requiredFields: ['content'],
    optionalFields: [],
  },
  'button': {
    label: 'Button Overlay',
    requiredFields: ['content', 'href'],
    optionalFields: [],
  },
};
